import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=6c5e8faa&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=6c5e8faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e8faa",
  null
  
)

export default component.exports